import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export const useIsLargeView = () => {
  const theme = useTheme();
  const isLargeView = useMediaQuery(theme.breakpoints.down('lg'));
  return isLargeView;
};
